import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { mockFAQs } from '../mock';

export const FAQSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-6 mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
            Frequently Asked
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-600 to-green-700">
              {" "}Questions
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Get answers to common questions about Agents.audio and how it can transform your practice.
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {mockFAQs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-gray-50 rounded-lg border-0 px-6"
            >
              <AccordionTrigger className="text-left font-semibold text-gray-900 hover:text-emerald-600 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        <div className="text-center mt-12 pt-8 border-t border-gray-200">
          <p className="text-gray-600 mb-4">
            Still have questions? Our team is here to help. You can also call our lead capture AI agent below.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="mailto:support@agents.audio"
              className="text-emerald-600 hover:text-emerald-700 font-medium"
            >
              sales@agents.audio
            </a>
            <span className="hidden sm:inline text-gray-400">|</span>
            <a
              href="tel:+1(855)560-3920"
              className="text-emerald-600 hover:text-emerald-700 font-medium"
            >
              +1(855)560-3920
            </a>
            
          </div>
        </div>
      </div>
    </section>
  );
};